import angular from 'angular';
import { AssignedEventsCalendarContainerComponent } from './assigned-events-calendar-container.component';

export const AssignedEventsCalendarModule = angular
    .module("apex.mainApp.eventsScheduling.assignedEventsCalendar", [])
    .component("apexAssignedEventsCalendarContainer", AssignedEventsCalendarContainerComponent)
    .name;
